import { matchPath, useLocation } from "react-router-dom";
import { headerConfig } from "../routes";
import { useSelector } from "react-redux";

export function useHeaderConfig() {
  const { pathname } = useLocation();

  const formTitle = useSelector((state) => state.forms.formDetailsData?.name);
  const woundDataRefreshDate = useSelector((state) => state.woundreport.reportSyncStatus?.woundDataRefreshUtc);
  const lookUpDataRefreshDate = useSelector((state) => state.woundreport.reportSyncStatus?.lookupDataRefreshUtc);
  const role = useSelector((state) => state.user?.role);

  const customerSubHeading = role === "MedlineAdministrator" ? "Customers" : role === "ExternalAdministrator" ? "Company Profile" : "";

  let matchedConfig = {};

  for (const path in headerConfig) {
    const match = matchPath({ path, end: true }, pathname);

    if (match) {
      const route = headerConfig[path];

      matchedConfig =
        typeof route.config === "function"
          ? route.config({
              match,
              redux: {
                formTitle,
                customerSubHeading,
                woundDataRefreshDate,
                lookUpDataRefreshDate,
              },
            })
          : route.config;

      break;
    }
  }

  return matchedConfig;
}
